module.exports = __webpack_public_path__ + "app/bento-components/video-list/media/close.svg";